import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrimaryNavigationComponent } from './global/components/primary-navigation/primary-navigation.component';
import { PredictorModule } from './predictor/predictor.module';
import { ManageResolver } from './predictor/resolvers/manage-resolver';
import { authenticatedUserResolver } from './predictor/resolvers/authenticated-user-resolver';
import { StudyAreaResolver } from './predictor/resolvers/study-area-resolver';
import { StudyAreaWorkflowComponent } from './predictor-enterprise-license/create-study-area/pages/study-area-workflow/study-area-workflow.component';

const routes: Routes = [
  {
    path: '',
    component: PrimaryNavigationComponent,
    resolve: {
      user: () => authenticatedUserResolver(),
    },
    children: [
      { path: '', redirectTo: 'predictor', pathMatch: 'full' },
      {
        path: '',
        loadChildren: () => PredictorModule,
        runGuardsAndResolvers: 'always',
        resolve: {
          studyArea: StudyAreaResolver,
        },
      },
      {
        path: 'studyarea',
        component: StudyAreaWorkflowComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
